 <template>
  <div>
    <div class="headers">
      <div class="date">Date</div>
      <div class="payment">Payment</div>
      <div class="principle">Principle</div>
      <div class="interest">Interest</div>
      <div class="balance">Balance</div>
    </div>
    <div v-if="Object.keys(state.ERRORS).length === 0" class="table-body">
      <div
        :class="{total:typeof item.total !== 'undefined', sub:typeof item.sub !== 'undefined'}"
        class="body"
        v-for="(item, index) in paymentDateAndTotals"
        :key="index"
      >
        <div
          v-if="typeof item.total === 'undefined' && typeof item.sub === 'undefined'"
          class="date"
        >{{item.date.format('MMM, DD, YYYY')}}</div>
        <div v-else class="date"><div class="value">{{item.date}}</div></div>
        <div
          class="payment"
          v-if="typeof item.noPayment === 'undefined'"
        >{{ currency(item.payment) }}</div>
        <div class="payment" v-else>{{ item.payment }}</div>
        <div class="principle">{{currency(item.monthlyPrinciple) }}</div>
        <div class="interest">{{currency(roundCurrency(item.monthlyInterest)) }}</div>
        <div
          v-if="typeof item.balance !== 'string'"
          class="balance"
        >{{currency(roundCurrency(item.balance)) }}</div>
        <div v-else class="balance">-----</div>
      </div>
    </div>
    <div class="error-table" v-else>
      <div
        class="body"
        v-for="(item, index) in new Array(state.TERM).fill(0,0,state.TERM)"
        :key="index"
      >
        <div class="date">---</div>
        <div class="payment">0</div>
        <div class="principle">0</div>
        <div class="interest">0</div>
        <div class="balance">0</div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from "moment";
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import { STATE, MUTATIONS, GETTERS, ACTIONS } from "../storeConstants";
import { currency, formatDate } from "../util/format";
import { roundCurrency, roundDollarsToCents } from "../util/bankersRound";

const { MODIFIED_TERM, PAYMENT } = GETTERS;

export default {
  methods: {
    currency: currency,
    roundCurrency: roundCurrency
  },
  computed: {
    ...mapGetters([MODIFIED_TERM, PAYMENT]),
    ...mapState({
      state: state => state.base
    }),
    paymentDateAndTotals() {
      return this.state.PAYMENT_DATA.reduce((accum, item, index) => {
        accum.push({
          ...item,
          payment:
            this.PAYMENT +
            this.state.INSURANCE_COST +
            this.state.PROPERTY_TAX +
            this.state.HOA_FEES
        });
        if (
          this.state.HOA_FEES +
            this.state.INSURANCE_COST +
            this.state.PROPERTY_TAX >
          0
        ) {
          accum.push({
            ...item,
            date: `Fees and Taxs`,
            monthlyInterest: 0,
            payment:
              this.state.HOA_FEES +
              this.state.INSURANCE_COST +
              this.state.PROPERTY_TAX,
            monthlyPrinciple: 0,
            balance: "-----",
            sub: true
          });
        }
        if (this.state.EXTRA_MONTHLY_PAYMENT_AMOUNT > 0) {
          accum.push({
            ...item,
            date: `Extra (monthly)`,
            monthlyInterest: 0,
            payment: this.state.EXTRA_MONTHLY_PAYMENT_AMOUNT,
            monthlyPrinciple: this.state.EXTRA_MONTHLY_PAYMENT_AMOUNT,
            balance: "-----",
            sub: true
          });
        }
        if (
          this.state.ANNUAL_PAYMENT_AMOUNT > 0 &&
          item.date.format("MMMM") === this.state.ANNUAL_PAYMENT_DATE
        ) {
          accum.push({
            ...item,
            date: `Extra  (annual)`,
            monthlyInterest: 0,
            payment: this.state.ANNUAL_PAYMENT_AMOUNT,
            monthlyPrinciple: this.state.ANNUAL_PAYMENT_AMOUNT,
            balance: "-----",
            sub: true
          });
        }
        if (
          this.state.ONE_TIME_PAYMENT_AMOUNT > 0 &&
          item.date.isSame(this.state.ONE_TIME_PAYMENT_DATE, "month")
        ) {
          accum.push({
            ...item,
            date: `Extra (one time)`,
            monthlyInterest: 0,
            payment: this.state.ONE_TIME_PAYMENT_AMOUNT,
            monthlyPrinciple: this.state.ONE_TIME_PAYMENT_AMOUNT,
            balance: "-----",
            sub: true
          });
        }

        if (item.date.month() === 11) {
          accum.push({
            ...item,
            date: `Total (as of ${item.date.year()})`,
            monthlyInterest: item.interest,
            monthlyPrinciple: item.principle,
            total: true,
            noPayment: true,
            payment: "---"
          });
        }
        return accum;
      }, []);
    }
  }
};
</script>

<style scoped lang="scss">
.amortization-table {
  height: 530px;
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: auto;
}

@media (min-width: 768px) {
  .amortization-table {
    overflow-x: hidden;
  }
}

.amortization-table > * {
  width: 100%;
  margin: auto;
  left: 0;
  position: relative;
}

.error-table {
  background-color: #e1e1e1;
}

.error-table .body {
  background-color: inherit;
}

.error-table .body > * {
  background-color: #e1e1e1;
}

.headers {
  text-transform: uppercase;
  font-size: 14px;
  color: #636363;
}

@media (min-width: 768px) {
  .headers {
    font-size: 12px;
  }
}

.headers div {
  font-weight: 400;
  background-color: #f3f3f3;
  border-top: 1px solid #c3c3c3;
}

.body,
.headers {
  display: flex;
  text-align: center;
  font-family: "Open Sans";
  font-weight: 400;
  background-color: #fff !important;
}

.body.total,
.headers.total {
  background-color: #fafafa !important;
}

.body.sub .date .value,
.headers.sub .date .value {
  word-break: break-word;
}

@media (min-width: 768px) {
  .body.sub > *,
  .headers.sub > * {
    font-size: 12px;
  }
  .body.sub .date,
  .headers.sub .date {
    font-size: 12px;
    padding-top: 0;
    padding-bottom: 0;
    width: calc(100% - 20px);
  }
  .body.sub .date .value,
  .headers.sub .date .value {
    font-size: 12px;
    padding-left: 20px;
  }
  .body.total,
  .headers.total {
    display: flex;
    background-color: #fafafa !important;
  }
  .body.total .date,
  .headers.total .date {
    padding-top: 0;
    padding-bottom: 0;
    padding-right: 48px;
    padding-left: 0;
  }
  .body.total > *,
  .headers.total > * {
    background-color: #fafafa;
  }
}

@media (min-width: 768px) and (min-width: 768px) {
  .body.total,
  .headers.total {
    display: flex;
  }
}

.body .body div,
.headers .body div {
  background-color: #fff;
}

.body div,
.headers div {
  padding-left: 8px;
  border-bottom: 1px solid #c3c3c3;
  min-width: 124px;
  max-width: 124px;
  font-size: 16px;
  font-weight: 400;
  line-height: 1.2;
  height: 55px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding-top: 12px;
  padding-bottom: 12px;
}

@media (min-width: 768px) {
  .body div,
  .headers div {
    height: auto;
    font-size: 14px;
    padding-top: 8px;
    padding-bottom: 8px;
  }
}

.body div.date,
.body div.date .value,
.headers div.date,
.headers div.date .value {
  min-width: 40px;
  max-width: 40px;
  padding-right: 40px;
}

.body div.date .value,
.headers div.date .value {
  padding-left: 0;
}

@media (min-width: 640px) {
  .body div.date,
  .headers div.date {
    min-width: calc(100% - 496px);
  }
  .body div.date .value,
  .headers div.date .value {
    min-width: unset;
    max-width: unset;
    padding-right: 40px;
    padding-left: 8px;
    border-bottom: none;
  }
}

@media (min-width: 768px) {
  .body div.date,
  .headers div.date {
    min-width: calc(100% - 541px);
  }
}
</style>